module.exports = "./img/d4a13dd74679434a1ec960e681e06630.png";